"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const formik_1 = require("formik");
const yup = __importStar(require("yup"));
const LoadingButton_1 = __importDefault(require("../../../components/LoadingButton"));
const InputField_1 = __importDefault(require("../../../components/InputField/InputField"));
const Alert_1 = __importDefault(require("../../../components/Alert"));
const react_router_dom_1 = require("react-router-dom");
const ChangePassword = ({ oldPassword = '' }) => {
    const [{ isLoading, errorMessage, confirmed, confirmSuccess }, setState] = (0, react_1.useState)({
        isLoading: false,
        errorMessage: '',
        confirmed: false,
        confirmSuccess: false,
    });
    const handleSubmit = (formValues) => {
        setState((prevState) => (Object.assign(Object.assign({}, prevState), { isLoading: true })));
        const updatedState = {
            isLoading: false,
            confirmed: true,
            confirmSuccess: true,
            errorMessage: '',
        };
        axios
            .put('/api/change-password', formValues)
            .catch((err) => {
            switch (err.message) {
                case 'error-code-995':
                    updatedState.errorMessage = __.trans('user.change-pw-err-995');
                    break;
                case 'error-code-993':
                case 'error-code-994':
                    updatedState.errorMessage = __.trans('user.change-pw-err-993-994');
                    break;
                default:
                    updatedState.errorMessage = err.message;
                    break;
            }
            updatedState.confirmSuccess = false;
        })
            .finally(() => {
            setState((prevState) => (Object.assign(Object.assign({}, prevState), updatedState)));
        });
    };
    const renderConfirmation = () => ((0, jsx_runtime_1.jsxs)(Alert_1.default, { color: confirmSuccess ? 'success' : 'danger', isOpen: confirmed, children: [__.trans(`${confirmSuccess ? 'user.password-change-successful' : 'user.password-change-unsuccessful'}`), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("br", {}), errorMessage] })] }));
    const renderForm = () => ((0, jsx_runtime_1.jsx)(formik_1.Formik, { initialValues: {
            oldPassword: oldPassword !== null && oldPassword !== void 0 ? oldPassword : '',
            newPassword: '',
            newPassword_confirmation: '',
        }, validationSchema: yup.object().shape({
            oldPassword: yup.string().required(__.trans('user.old-password-required')),
            newPassword: yup
                .string()
                .min(8, __.trans('user.password-min-length'))
                .required(__.trans('user.new-password-required')),
            newPassword_confirmation: yup
                .string()
                .oneOf([yup.ref('newPassword'), undefined], __.trans('user.passwords-must-match')),
        }), onSubmit: handleSubmit, children: (0, jsx_runtime_1.jsxs)(formik_1.Form, { children: [(0, jsx_runtime_1.jsx)(InputField_1.default, { name: 'oldPassword', id: 'oldPassword', type: 'password', label: __.trans('user.current-password') }), (0, jsx_runtime_1.jsx)(InputField_1.default, { name: 'newPassword', id: 'newPassword', type: 'password', label: __.trans('user.new-password') }), (0, jsx_runtime_1.jsx)(InputField_1.default, { name: 'newPassword_confirmation', id: 'newPassword_confirmation', type: 'password', label: __.trans('user.new-password-confirm') }), (0, jsx_runtime_1.jsx)(LoadingButton_1.default, { isLoading: isLoading, disabled: confirmSuccess, children: (0, jsx_runtime_1.jsx)("button", { type: "submit", className: "btn theme-button-primary", children: __.trans('user.change-password') }) })] }) }));
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("h3", { children: __.trans('user.change-password') }), renderConfirmation(), !confirmSuccess && renderForm(), (0, jsx_runtime_1.jsx)("div", { className: "mt-4", children: (0, jsx_runtime_1.jsx)(react_router_dom_1.NavLink, { to: "/auth/login", children: __.trans('register.go-back') }) })] }));
};
exports.default = ChangePassword;
